import React from 'react';
import { Page, Link, Text, View, Document, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    paddingLeft: 40,
    paddingRight: 40,
    paddingTop: 20,
    paddingBottom: 20,
  },
  section: {
    marginBottom: 10,
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: 'space-between',
  },
  companyName: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  companyAddress: {
    fontSize: 9,
    color: '#555555',
  },
  name: {
    fontSize: 12,
    marginBottom: 4
  },
  address: {
    fontSize: 11,
    lineHeight: 1.3,
  },
  text: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  pageTitle: { fontSize: 12, fontWeight: 'bold', textAlign: 'center', width: '100%', textDecoration: 'underline' },
  textRow: { display: 'flex', flexDirection: 'row', alignItems: 'flex-start', position: 'relative', marginBottom: 10 },
  lCount: { fontWeight: 'bold', fontSize: 12, position: 'absolute' },
  para: { fontSize: 11, paddingLeft: 20, lineHeight: 1.2 },
  bold: { fontWeight: 'bold' },
});

const ClientCareGeneralPdf = ({ data }) => (
  <Document>
    <Page size="A4" style={[styles.page, { position: 'relative' }]} >
      <View style={styles.flexRow}>
        <View style={styles.companySection}>
          <Image
            style={{
              marginBottom: 10,
              width: '120px',
              alignSelf: 'flex-end',
            }}
            src="/logo192.png"
          />
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <Text style={styles.companyName}>SKA NANKANA SAHIB SOLICITORS</Text>
          <Text style={styles.companyAddress}>
            101A Soho Hill, Hockley,
          </Text>
          <Text style={styles.companyAddress}>
            Birmingham, B19 1AY.
          </Text>
          <Text style={styles.companyAddress}>
            <Text style={{ fontWeight: 'bold', marginRight: 3 }}>(T):</Text> 0121 493 4730 | 0121 493 4731
          </Text>
          <Text style={styles.companyAddress}>
            <Text style={{ fontWeight: 'bold', marginRight: 3 }}>(Emergency Only):</Text> 07869 720 081 |
          </Text>
          <Text style={styles.companyAddress}>
            07861 460 640
          </Text>
          <Text style={styles.companyAddress}>
            <Text style={{ fontWeight: 'bold', marginRight: 3 }}>(E):</Text><Link href='mailto:office@skasolicitors.co.uk'>Office@SKASolicitors.co.uk</Link>
          </Text>
        </View>
      </View>

      <View style={[styles.flexRow, { marginTop: 20 }]}>
        <View>
          <View style={{ marginBottom: 10 }}>
            <View>
              <Text style={styles.name}>Dear <Text style={{ color: '#ff0000' }}>{data.title} {data.surname}</Text>,</Text>
            </View>
            <View>
              {data.number_street ? <Text style={styles.address}>{data.number_street},</Text> : ""}
              {data.city ? <Text style={styles.address}>{data.city},</Text> : ""}
              {data.country ? <Text style={styles.address}>{data.country},</Text> : ""}
              {<Text style={styles.address}>{data.postal_code}</Text>}
            </View>
          </View>
        </View>
        <View style={[{ alignItems: 'flex-end' }]}>
          <View style={[styles.container, { marginBottom: 10 }]}>
            <Text style={styles.text}>File Ref Number: AA/SK/BHAM/{data.id}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.text}>Date: {data.date}</Text>
          </View>
        </View>
      </View>


      <View style={[styles.flexRow, { marginTop: 5 }]}>
        <View style={styles.section}>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Text style={[styles.pageTitle, { textAlign: 'left', textDecoration: 'none' }]}>Re: Your <Text style={{ color: 'brown' }}>{data.matter_type}</Text> Matter</Text>
          </View>

          <View style={[styles.flexRow, { marginTop: 0 }]}>
            <View style={styles.section}>
              <View style={styles.textRow}>
                <Text style={[styles.para, { paddingLeft: 0 }]}>
                  We thank you for instructing us in relation to your matter. We hope that we will be able to assist and guide you in this
                  case. This is a general customer care and introductory letter, to give you enough information on the standards of our
                  services to you. You will receive a more specific letter from us very soon or you may have already received one from
                  your case worker or we may have already discussed this with you as to your expectations, the course of action and the
                  likely outcome.
                </Text>
              </View>
            </View>
          </View>
          <View style={[styles.flexRow, { marginTop: 0 }]}>
            <View style={styles.section}>
              <View style={[styles.section, { marginBottom: 15 }]}>
                <Text style={[styles.pageTitle, { textAlign: 'left' }]}>Your Instructions:</Text>
              </View>
              <View style={styles.textRow}>
                <Text style={[styles.para, { paddingLeft: 0 }]}>
                  We have been instructed by you as you wish us to advise and represent you in relation to your matter, as specified on
                  the invoice issued by us in relation to this specific retainer of our services. We further write to confirm that we have agree
                  initial fixed fee of initial stages as discussed and the same is mentioned in copies of invoice enclosed herewith. Should
                  you instruct us at any subsequent stages we would advise you of the fees prior to your instructions. We may not send a
                  further client care letter but will retain a note of your instructions and the agreed fee in your file. Where we agree a fixed
                  fee, we shall send you an invoice as soon as you have agreed to the fee and for us to continue with any subsequent
                  work, if not enclosed herewith.
                </Text>
              </View>
            </View>
          </View>
          <View style={[styles.flexRow, { marginTop: 0 }]}>
            <View style={styles.section}>
              <View style={[styles.section, { marginBottom: 15 }]}>
                <Text style={[styles.pageTitle, { textAlign: 'left' }]}>Our Advice:</Text>
              </View>
              <View style={styles.textRow}>
                <Text style={[styles.para, { paddingLeft: 0 }]}>
                  You will need to bring all the evidence requested by your caseworker to establish your case and we will advise you
                  accordingly at this stage of the matter and represent you as appropriate at an appropriate level, within the parameters
                  of the retainer of our services.
                </Text>
              </View>
            </View>
          </View>
          <View style={[styles.flexRow, { marginTop: 0 }]}>
            <View style={styles.section}>
              <View style={[styles.section, { marginBottom: 15 }]}>
                <Text style={[styles.pageTitle, { textAlign: 'left' }]}>Actions to be taken:</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
                <Text style={[styles.para, { paddingLeft: 0 }]}>
                  Usually include:
                </Text>
                <Text style={[styles.para, { paddingLeft: 0 }]}>
                  1] To draft and submit your application and to represent you at a forum or a venue.
                </Text>
                <Text style={[styles.para, { paddingLeft: 0 }]}>
                  2] To advise you as to the strength of your case.
                </Text>
                <Text style={[styles.para, { paddingLeft: 0 }]}>
                  3] To advise you in relation to your application and documents to support your case.
                </Text>
                <Text style={[styles.para, { paddingLeft: 0 }]}>
                  4] To keep you informed of any updates, if any, by a mean you understand easily.
                </Text>
                <Text style={[styles.para, { paddingLeft: 0 }]}>
                  5] There may be several levels of your matter in future and to advise you accordingly as to different stages at different
                  levels and agree accordingly as to the cost and conduct etc. Your current instructions and retainer may not include
                  various stages as may be required and there has to be agreed between you and us the costs accordingly.
                </Text>

              </View>
            </View>
          </View>
        </View>
      </View>

      <View style={{ position: 'absolute', bottom: 30, left: 10, right: 10 }}>
        <View style={{ marginTop: 10, paddingTop: 5, textAlign: 'center' }}>
          <Text style={{ fontSize: 9, fontWeight: 'bold' }}>AUTHORISED AND REGULATED BY THE SOLICITORS REGULATION AUTHORITY: 659308</Text>
          <Text style={{ fontSize: 9, fontWeight: 'bold' }}>Mr. Arman Alam – Barrister at Law - Principal</Text>
          <Text style={{ fontSize: 6, fontStyle: 'italic' }}>SKA Nankana Sahib Solicitors is trading name of Thara Legal Ltd,, registered in England and Wales Companies House No: 11906084, whose registered office is at</Text>
          <Text style={{ fontSize: 7, fontStyle: 'italic' }}>144 Desborough Road, High Wycombe, England, United Kingdom</Text>
          <Text style={{ fontSize: 7 }}>We do not accept service of issues and documents by email and fax, all matters must be delivered by Royal Mail or Similar Services.</Text>
          <Text style={{ fontSize: 7 }}>We are committed to promoting equality and diversity and ensuring the security of your private personal information.</Text>
        </View>
      </View>

    </Page>
    <Page size="A4" style={[styles.page, { paddingTop: 40, paddingBottom: 40 }]} >

      <View style={[styles.flexRow, { marginTop: 0 }]}>
        <View style={styles.section}>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Text style={[styles.pageTitle, { textAlign: 'left' }]}>Responsibility:</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              Your case will be supervised by Mr. Arman Alam [Barrister at Law] who has ultimate responsibility for your atter. One
              of his assistants, your caseworker, will have the day-to-day conduct of your matter. We shall keep you informed about
              your case on a regular basis. If you do not hear from us for more than 3 months, please contact us and speak to your
              allocated case worker and or make an appointment to see us, three monthly appointments are not chargeable. Any
              other appointments are chargeable as may be the rate time to time for consultation sessions.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              Whilst we do hope that you should never have a concern about our service, however, should you ever need to complain
              please at first instance speak with the person who is dealing with your case. If you are still not satisfied with the response
              then please write to Mr. A ALAM, who is the compliance partner at this practice. The envelope should be marked
              “PRIVATE AND CONFIDENTIAL”. He will then investigate your complaint and write to you. Please also refer to our
              “Complaints Procedure” letter enclosed herewith.
            </Text>
          </View>
        </View>
      </View>

      <View style={[styles.flexRow, { marginTop: 0 }]}>
        <View style={styles.section}>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Text style={[styles.pageTitle, { textAlign: 'left' }]}>Cost Information:</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              We are a private practice. Our usual standard charge for file opening and anything up to 3 hours work in connection
              with a matter is £250/- plus VAT to be paid prior to us carrying out any work in fixed fee matters. This includes all type
              of time incurred on the case, initial attending consideration advice and establishing course of action. Any subsequent
              time is usually charged at a rate of £100 plus VAT to £275 plus VAT per hour depending on the level of expertise of our
              staff or on a fixed fee basis. Please note that it is our policy to have at least £250/- on account of our cost as appropriate
              prior to carrying out the work, on hourly rate basis too. Please ensure you understand the basis of your instructions to
              us and retention of our services. Please note that our fixed or non-fixed professional charges do not include any
              disbursements i.e. Home Office Fee, Counsel Fee and or Court Fee etc. These fees will be required to be paid in
              advance by you at the relevant time, when these are likely to be incurred.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              If we have agreed to a fixed fee in your specific matter to a stage/level, please refer to the terms of business and
              arrangement of fixed fee letter enclosed. Please also refer to our detailed client care information. In fixed fee matters we
              rarely agree to pay any likely disbursements. It is however possible for you to make a cheque payable directly to the
              third party to cover the cost of the disbursement. If we make a payment from office account, that amount has to be paid
              to us by you. Otherwise, any fee received from you to pay for disbursements is paid in our client bank account from
              where we will pay for the disbursements on your behalf. Please see the invoice issued for the agreed fixed fee. The
              agreed fixed fee is unalterable for the purpose they are raised for whether the work proceed to completion or not and
              payable forthwith. Any appointments on your matter which are not called for by us or are for your own satisfaction are
              chargeable. Currently we charge £50.00 for such appointments. It is advisable that you wait for your caseworker to call
              you.
            </Text>
          </View>
        </View>
      </View>

      <View style={[styles.flexRow, { marginTop: 0 }]}>
        <View style={styles.section}>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Text style={[styles.pageTitle, { textAlign: 'left' }]}>Further Cost Information</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              Solicitor and Client costs are the amount you are liable to pay for work done on your instructions where we undertake
              work in the carrying out of your instructions as per the agreed retainer.
              Costs between the parties are which the court orders the unsuccessful litigant to pay to the successful litigant the
              reasonably incurred costs. The amount is assessed by the court and may not cover in full the cost of the solicitor, which
              the successful litigant is bound to pay. The same is the case for the unsuccessful litigant, the complete costs has to be
              paid to your solicitor. The enforcement of payment is a different matter and you may have to bear the further costs for
              recovering from the losing party. If you are unsuccessful, you will be liable to pay our costs and may be liable to pay
              other party’s costs as this may be assessed by the court.
            </Text>
          </View>
        </View>
      </View>

      <View style={[styles.flexRow, { marginTop: 0 }]}>
        <View style={styles.section}>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Text style={[styles.pageTitle, { textAlign: 'left' }]}>Terminating your instructions:</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              You are free to terminate your instructions at any time. Likewise, we are free to stop acting for you. However, we shall
              only stop acting for you if we believe that you are behaving unreasonably and only after prior consultation with you. We
              have notified you that we will preserve our lean on the file and its content if there is an outstanding fee on the file, these
              are well established legal rights which you must be aware of and termination of instructions, does not mean that we are
              liable to return your file until the outstanding balance is paid for. At times we may not be able to act any further no matter
              what the stage the matter is at if the agreed fee is not paid for well in advance of a crucial stage of the matter.
            </Text>
          </View>
        </View>
      </View>

      <View style={[styles.flexRow, { marginTop: 0 }]}>
        <View style={styles.section}>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Text style={[styles.pageTitle, { textAlign: 'left' }]}>Free Legal Advice:</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              We have advised you that you may be in a position to obtain free legal advice and representation from certain
              organisations and legally aided solicitors. You have however shown your satisfaction that you are in a position to pay
              our charges. We are a private legal practice, and unable to offer free advice and representation.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              Once again, we take the opportunity of thanking you for your instructions and look forward to seeing you again soon. If
              you have any questions, please do not hesitate to contact us we would be pleased to answer.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              Yours sincerely,
            </Text>
          </View>
        </View>
      </View>

      <View style={[styles.flexRow, { marginTop: 0 }]}>
        <View style={styles.section}>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Text style={[styles.pageTitle, { textAlign: 'left', textDecoration: 'none' }]}>SKA NANKANA SAHIB SOLICITORS</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              Encl: Further client care terms of business.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              &bull; Terms and conditions of the business
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              &bull; Invoice
            </Text>
          </View>
        </View>
      </View>


    </Page >
  </Document >
);

export default ClientCareGeneralPdf;
